import { addMigration } from "./all";

addMigration({
  "sóhněla:du": "sóhně:la:du",
  "Agwa̋:sa wigě:dôli dida:náɂnv̋ɂi.": "Agwa̋:sa wigě:dô:li dida:náɂnv̋ɂi.",
});
